import { ShippingMethod, fieldsConfig, FieldsTypes } from '@pages/checkout-app/types';
import { DELIVERY_PROMISE_ARRIVAL_DISPLAY_TEXT } from '@pages/checkout-app/configs';

const AB_TEST_LIVE_RATE_CONFIG: fieldsConfig[] = [
  {
    fieldName: 'name',
    defaultValue: '',
    type: FieldsTypes.TEXT,
  },
  {
    fieldName: 'notes',
    defaultValue: '',
    type: FieldsTypes.TEXT,
  },
  {
    fieldName: 'percentageOfCarrierCost',
    defaultValue: 0,
    type: FieldsTypes.NUMBER,
  },
  {
    fieldName: 'flatAmount',
    defaultValue: 0,
    type: FieldsTypes.NUMBER,
  },
  {
    fieldName: 'deliveryPromiseMax',
    defaultValue: 0,
    type: FieldsTypes.NUMBER,
  },
  {
    fieldName: 'deliveryPromiseMin',
    defaultValue: 0,
    type: FieldsTypes.NUMBER,
  },
  {
    fieldName: 'displayEstDelivery',
    defaultValue: false,
    type: FieldsTypes.TOGGLE,
  },
  {
    fieldName: 'displayEstimatedDeliveryBusinessDays',
    defaultValue: false,
    type: FieldsTypes.CHECKBOX,
  },
  {
    fieldName: 'calculatePackageDimension',
    defaultValue: false,
    type: FieldsTypes.CHECKBOX,
  },
  {
    fieldName: 'rateConversion',
    defaultValue: 'exact_rate',
    type: FieldsTypes.RADIO_BUTTONS,
  },
  {
    fieldName: 'percentTestVariantTraffic',
    defaultValue: 50,
    type: FieldsTypes.NUMBER,
  },
  {
    fieldName: 'appearanceLimit',
    defaultValue: null,
  },
  {
    fieldName: 'hideVariantB',
    defaultValue: false,
    type: FieldsTypes.TOGGLE,
  },
  {
    fieldName: 'disableRatesOptimization',
    defaultValue: false,
    type: FieldsTypes.TOGGLE,
  },
  ...DELIVERY_PROMISE_ARRIVAL_DISPLAY_TEXT,
];

const AB_TEST_DOMESTIC_CONFIG: fieldsConfig[] = [
  {
    fieldName: 'name',
    defaultValue: '',
    type: FieldsTypes.TEXT,
  },
  {
    fieldName: 'notes',
    defaultValue: '',
    type: FieldsTypes.TEXT,
  },
  {
    fieldName: 'rate',
    defaultValue: 0,
    type: FieldsTypes.NUMBER,
  },
  {
    fieldName: 'maxOrderPriceRange',
    defaultValue: 0,
    type: FieldsTypes.NUMBER,
  },
  {
    fieldName: 'minOrderPriceRange',
    defaultValue: 0,
    type: FieldsTypes.NUMBER,
  },
  {
    fieldName: 'additionalPriceRanges',
    defaultValue: [],
    controlType: 'array',
  },
  {
    fieldName: 'deliveryPromiseMax',
    defaultValue: 0,
    type: FieldsTypes.NUMBER,
  },
  {
    fieldName: 'deliveryPromiseMin',
    defaultValue: 0,
    type: FieldsTypes.NUMBER,
  },
  {
    fieldName: 'displayEstDelivery',
    defaultValue: false,
    type: FieldsTypes.CHECKBOX,
  },
  {
    fieldName: 'displayEstimatedDeliveryBusinessDays',
    defaultValue: false,
    type: FieldsTypes.CHECKBOX,
  },
  {
    fieldName: 'percentTestVariantTraffic',
    defaultValue: 50,
    type: FieldsTypes.NUMBER,
  },
  {
    fieldName: 'appearanceLimit',
    defaultValue: null,
  },
  {
    fieldName: 'hideVariantB',
    defaultValue: false,
    type: FieldsTypes.TOGGLE,
  },
  {
    fieldName: 'disableRatesOptimization',
    defaultValue: false,
    type: FieldsTypes.TOGGLE,
  },
  ...DELIVERY_PROMISE_ARRIVAL_DISPLAY_TEXT,
];

export const ABTestConfig: { [key: string]: fieldsConfig[] } = {
  [ShippingMethod.DOMESTIC_LIVE_RATE]: AB_TEST_LIVE_RATE_CONFIG,
  [ShippingMethod.DOMESTIC]: AB_TEST_DOMESTIC_CONFIG,
  [ShippingMethod.INTERNATIONAL_FIXED]: AB_TEST_DOMESTIC_CONFIG,
  [ShippingMethod.INTERNATIONAL_LIVE_RATE]: AB_TEST_LIVE_RATE_CONFIG,
  [ShippingMethod.INTERNATIONAL_FIXED_LIVE_RATE]: AB_TEST_LIVE_RATE_CONFIG,
  [ShippingMethod.FIXED_LIVE_RATE]: AB_TEST_DOMESTIC_CONFIG,
  [ShippingMethod.LOCAL]: AB_TEST_DOMESTIC_CONFIG, // same as domestic fields
  [ShippingMethod.STORE_PICK_UP]: AB_TEST_DOMESTIC_CONFIG,
};

export enum ColumnTypes {
  CURRENCY = 'currency',
  PERCENT = 'percent',
  TITLE = 'title',
}

export const ABTest_Columns = [
  {
    prop: 'variant',
    name: 'Variant',
    type: ColumnTypes.TITLE,
  },
  {
    prop: 'conversionRate',
    name: 'Selection rate',
    hideName: true,
    type: ColumnTypes.PERCENT,
  },
  {
    prop: 'avgOrderValue',
    name: 'Avg order value',
    hideName: true,
    type: ColumnTypes.CURRENCY,
  },
  {
    prop: 'conversionsOfVisits',
    hideName: true,
    name: 'Selections / visits',
  },
];

export enum ACTIONS {
  EDIT = 'edit',
  CREATE = 'create',
  DELETE = 'delete',
  STOP = 'stop',
  VIEW = 'view',
  DUPLICATE = 'duplicate',
  EDIT_RUNNING_ABTEST = 'edit_running_abtest',
}
